import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { SelectCaseDialogComponent } from '../../actions/selectCaseDialog/select-case-dialog.component';

class Page {
  size: number;
}
export interface DialogData {
  contentData: [];
}
@Component({
  selector: 'app-case-dialog',
  templateUrl: './case-dialog.component.html',
  styleUrls: ['./case-dialog.component.scss'],
})
export class CaseDialogComponent implements OnInit {
  sectionId: any;
  unitId: any;
  listboxData: any;
  page = new Page();
  ColumnMode = ColumnMode;
  selected = [];
  content2: any;
  output: any;

  columnConfig2 = [
    {
      name: 'subName',
      displayName: 'Process',
    },
    /*  {
      name: 'corrSub',
      displayName: '',
    },
    {
      name: 'dbSchema',
      displayName: '',
    }, */
  ];

  constructor(
    public http: HttpClient,
    public dialogRef: MatDialogRef<CaseDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public cdf: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.content2 = this.data.contentData;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    if (this.output) {
      this.dialogRef.close(this.output);
    } else {
      this.dialog.open(SelectCaseDialogComponent, {
        data: 'Please select Process.',
      });
    }
  }

  getData(data: Event): void {
    this.output = data;
  }
}
